/**
 * REFERRAL-AGENT SHELL (2026-11-01).
 *
 * An R9 has no shop and no staff profile, so they cannot inherit SidebarLayout — before this they got a
 * single 30-pixel top bar and one page. This is their own shell: the same navigation idea the business
 * dashboard uses, without borrowing a single shop permission.
 *
 * R1/R4 keep their existing sidebars and continue to reach the partner view at /dashboard/referrals; this
 * shell is only ever rendered for the agent area.
 */
import React, { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { logout } from "../../utils/authUtils";
import "./ReferralAgentArea.css";

const NAV = [
  { to: "/dashboard/agent", label: "Overview", end: true },
  { to: "/dashboard/agent/referrals", label: "Referrals" },
  { to: "/dashboard/agent/earnings", label: "Earnings" },
  { to: "/dashboard/agent/payouts", label: "Payouts" },
  { to: "/dashboard/agent/links", label: "Share links" },
  { to: "/dashboard/agent/profile", label: "Profile" },
];

function readName() {
  try {
    const raw = localStorage.getItem("ogestyle_user");
    if (raw) {
      const user = JSON.parse(raw);
      const full = [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim();
      if (full) return full;
      if (user?.email) return user.email;
    }
    return localStorage.getItem("ogestyle_email") || "Agent";
  } catch (_) {
    return "Agent";
  }
}

export default function AgentLayout() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const name = readName();

  // A drawer left open over a freshly loaded page hides the very content that was requested.
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <div className="agent-shell">
      <div
        className={`agent-scrim ${open ? "is-open" : ""}`}
        onClick={() => setOpen(false)}
        aria-hidden="true"
      />
      <aside className={`agent-sidebar ${open ? "is-open" : ""}`}>
        <div className="agent-brand-row">
          <Link to="/dashboard/agent" className="agent-brand">
            OGESTYLE<span className="agent-brand-sub">Referral programme</span>
          </Link>
        </div>
        <nav className="agent-nav">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end}>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="agent-sidebar-foot">
          <span className="agent-foot-name" title={name}>
            {name}
          </span>
          <button type="button" className="agent-foot-out" onClick={() => logout()}>
            Sign out
          </button>
        </div>
      </aside>

      <div className="agent-main">
        <div className="agent-mobile-bar">
          <button
            type="button"
            className="agent-mobile-toggle"
            onClick={() => setOpen((prev) => !prev)}
            aria-expanded={open}
            aria-label="Toggle navigation"
          >
            ☰
          </button>
          <span className="agent-mobile-title">Referral programme</span>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
